/** Round to 2 decimals. */
export const r2 = (v: number): number => Math.round(v * 100) / 100;
/** Round to 3 decimals. */
export const r3 = (v: number): number => Math.round(v * 1000) / 1000;

/** The p-th percentile of an ascending array (nearest rank; 0 when empty). */
export const pct = (sorted: number[], p: number): number => (sorted.length ? sorted[Math.min(sorted.length - 1, Math.max(0, Math.ceil((p / 100) * sorted.length) - 1))]! : 0);

/** p50, p95, p99, worst and mean of a sample (any order), rounded to 2 decimals. */
export function summarize(vals: number[]): { p50: number; p95: number; p99: number; worst: number; mean: number } {
  const s = [...vals].sort((a, b) => a - b);
  const mean = s.reduce((a, b) => a + b, 0) / Math.max(1, s.length);
  return { p50: r2(pct(s, 50)), p95: r2(pct(s, 95)), p99: r2(pct(s, 99)), worst: r2(s.at(-1) ?? 0), mean: r2(mean) };
}

/** The listed keys of an object. */
export function pick<T extends object, K extends keyof T>(o: T, ...keys: K[]): Pick<T, K> {
  const out = {} as Pick<T, K>;
  for (const k of keys) out[k] = o[k];
  return out;
}
